import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import * as queryString from "query-string";
import { Helmet } from "react-helmet-async";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import UserOverview from "../../components/detail/UserOverview";
import UserDetails from "../../components/detail/UserDetails";
// import UserChangeLog from "../../components/detail/UserChangeLog";
// import AccessProfilesTab from "../../components/detail/AccessProfilesTab";
import ChangeLogTab from "../../components/detail/ChangeLogTab";
import api from "../../api";
import AdminDetail from "../people/AdminDetail";
import AssetHasTag from "../../components/AssetHasTag";
import UploadImgModal from "../../components/UploadImgModal";
import {
  blobToFile,
  compressPic,
  dataURLtoBlob,
  // filterStorage,
} from "../../utils/staticMethods";
import NotyfContext from "../../contexts/NotyfContext";

const UsersEdit = () => {
  const location = useLocation();
  const { id, direct } = queryString.parse(location.search);
  const [userPerson, setUserPerson] = useState({});
  const [userSession, setUserSession] = useState({});
  const [userPermissionAccessProfile, setUserPermissionAccessProfile] =
    useState({});
  const [systemAverages, setSystemAverages] = useState([]);
  const [tab, setTab] = useState(direct ?? "overview");
  const [picture, setPicture] = useState();
  const [showUpload, setShowUpload] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);
  const notify = useContext(NotyfContext);

  const onDelete = () => {
    api.delete(`files/people/${id}/profilepic`).then(() => {
      notify.open({
        type: "success",
        message: "Changes Saved",
      });
      setPicture(null);
      setShowUpload(false);
    });
  };

  const onUpload = () => {
    if (!uploadFile || uploadFile.length === 0) return;
    let reader = new FileReader();
    reader.onload = function (evt) {
      let replaceSrc = evt.target.result;
      compressPic(replaceSrc, (base) => {
        let blob = dataURLtoBlob(base);
        let miniFile = blobToFile(
          blob,
          "new" + uploadFile[0].name,
          uploadFile[0].type
        );
        let data = new FormData();
        data.append("uploadedFile", miniFile);
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        api
          .post(`files/people/${id}/profilepic`, data, config)
          .then(() => {
            notify.open({
              type: "success",
              message: "Changes Saved",
            });
            setShowUpload(false);
            getPicture(id, setPicture);
          })
          .catch((err) => {
            notify.open({
              type: "error",
              message: err,
            });
          });
      });
    };
    reader.readAsDataURL(uploadFile[0]);
  };

  const handleUpdateData = () => {
    getUserPerson(id, setUserPerson);
  };

  useEffect(() => {
    return () => {};
  }, []);

  useEffect(() => {
    if (id) {
      getUserPerson(id, setUserPerson);
      getUserSession(id, setUserSession);
      getPicture(id, setPicture);
      getSystemAverages(id, setSystemAverages);
    }
  }, [id]);

  useEffect(() => {
    if (userPerson && userPerson.permissionId) {
      getUserPermissionAccessProfile(
        userPerson.permissionId,
        setUserPermissionAccessProfile
      );
    } else {
      setUserPermissionAccessProfile({});
    }
  }, [userPerson]);

  return (
    <React.Fragment>
      <Helmet defer={false} title={userPerson.compoundName || "Users"} />
      <Container fluid className="p-0">
        {userPerson.compoundName && (
          <h1 className="h3 mb-3">
            {`${userPerson.compoundName} ${
              userPerson.reference ? `(${userPerson.reference})` : ""
            }`}
          </h1>
        )}
        <Row>
          <Col md="4" xl="3">
            {picture && (
              <div className="p-3 bg-white border-bottom">
                <img
                  alt="profile"
                  className="w-100 cursor-pointer"
                  src={picture}
                  onClick={() => {
                    if (userPerson?.editPeople || userPerson?.id === id) {
                      setShowUpload(true);
                    }
                  }}
                />
              </div>
            )}
            <AssetHasTag
              apiName="people"
              handleUpdateData={handleUpdateData}
              id={id}
              hashTags={userPerson.hashTags}
            />
            {!picture &&
              (userPerson?.editPeople || userPerson?.id === id) &&
              userPerson?.role !== "Root" && (
                <div className="border-top p-3 bg-white">
                  <span
                    className="text-primary cursor-pointer"
                    onClick={() => setShowUpload(true)}
                  >
                    Add Profile Picture
                  </span>
                </div>
              )}
          </Col>
          <Col md="8" xl="9" className="mt-3 mt-sm-0">
            <div className="tab">
              <Tabs
                id="controlled-tab-example"
                activeKey={tab}
                onSelect={(k) => setTab(k)}
                variant="tabs"
              >
                <Tab
                  eventKey="overview"
                  title="Overview"
                  mountOnEnter={true}
                  unmountOnExit={false}
                >
                  <UserOverview
                    user={userPerson}
                    session={userSession}
                    profile={userPermissionAccessProfile}
                    systemAverages={systemAverages}
                    setTab={setTab}
                  />
                </Tab>
                <Tab
                  eventKey="details"
                  title="Details"
                  mountOnEnter={true}
                  unmountOnExit={false}
                >
                  <UserDetails
                    apiName={"people"}
                    asset={userPerson}
                    setAsset={() => {
                      getUserPerson(id, setUserPerson);
                    }}
                  />
                </Tab>
                {userPerson.role !== "Admin" && (
                  <Tab
                    eventKey={"system_access"}
                    title="System Access"
                    mountOnEnter={true}
                    unmountOnExit={false}
                  >
                    <AdminDetail
                      setPerson={() => {
                        getUserPerson(id, setUserPerson);
                      }}
                      data={userPerson}
                    />
                  </Tab>
                )}
                {/*
               <Tab
                eventKey={"access_profiles"}
                title="Access Profiles"
                mountOnEnter={true}
                unmountOnExit={false}
              >
                <AccessProfilesTab id={id} type={"people"} />
              </Tab>
              */}
                <Tab
                  eventKey="change_log"
                  title="Change Log"
                  mountOnEnter={true}
                  unmountOnExit={false}
                >
                  <ChangeLogTab id={id} type={"userperson"} />
                </Tab>
              </Tabs>
            </div>
          </Col>
        </Row>
      </Container>
      <UploadImgModal
        setUploadFile={(e) => setUploadFile(e)}
        showUpload={showUpload}
        onDelete={onDelete}
        onHide={() => setShowUpload(false)}
        picture={picture}
        onUpload={onUpload}
      />
    </React.Fragment>
  );
};

export default UsersEdit;

function getUserPerson(id, setUserPerson) {
  api({
    method: "GET",
    url: `people/${id}`,
  })
    .then((response) => {
      setUserPerson(response.data);
    })
    .catch((reason) => {})
    .finally(() => {});
}

function getUserSession(id, setUserSession) {
  api({
    method: "GET",
    url: `usersessions/${id}`,
  })
    .then((response) => {
      setUserSession(response.data);
    })
    .catch((reason) => {
      setUserSession({});
    })
    .finally(() => {});
}

// systemaverages

function getSystemAverages(id, setSystemAverages) {
  api({
    method: "GET",
    url: "usersessions/systemaverages",
  })
    .then((response) => {
      setSystemAverages(response.data);
    })
    .catch((reason) => {
      setSystemAverages([]);
    })
    .finally(() => {});
}

function getPicture(id, setPicture) {
  api({
    method: "GET",
    url: `files/people/${id}/profilepic`,
    responseType: "arraybuffer",
  })
    .then((response) => {
      let blob = new Blob([response.data], { type: "img/jpeg" });
      let url = (window.URL || window.webkitURL).createObjectURL(blob);
      setPicture(url);
    })
    .catch((reason) => {
      setPicture(null);
    })
    .finally(() => {});
}

function getUserPermissionAccessProfile(permissionId, setPermission) {
  api({
    method: "GET",
    url: `accessprofiles/${permissionId}`,
  }).then((response) => {
    setPermission(response.data);
  });
}
